// extracted by mini-css-extract-plugin
module.exports = {"container":"DynamicSections_container__a63rf","poolMobile":"DynamicSections_poolMobile__THQLa"};